<template>
    <v-row>
        <v-col md="12" class="page-header">
            <h2>
                <span>Alterar Senha</span>
            </h2>
        </v-col>
        <v-col md='12'>
            <v-form
                v-model="valid"
                ref="form"
            >
                
                <p>Para sua segurança, precisamos que você confirme seu login e CPF cadastrados.</p>
                <p>Será enviado um e-mail com os procedimentos para que você possa recuperar seu acesso.</p>
                            
                    
                <v-row>
                    <v-col cols="12" sm="12" md="6" lg="4">  
                        <v-text-field
                        prepend-icon="person"
                        maxlength="50"
                        required
                        clearable
                        outlined
                        v-model="login"
                        label="Login"></v-text-field>                             
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12" md="6" lg="4">
                        <v-text-field-cpf
                            label="Número do CPF"
                            v-model="cpf"
                            v-bind:properties="{
                                readonly: false,
                                disabled: false,
                                outlined: true,
                                clearable: true,
                                placeholder: '',
                                required: true,
                            }"
                            v-bind:options="{
                                outputMask: '###########',
                                empty: '',
                                applyAfter: true,
                            }"
                        />    
                    </v-col>
                </v-row>               
                <v-row>
                    <v-col cols="12" sm="12" md="6" lg="4">
                        <v-btn
                            @click="submit"
                            elevation="0"
                            color="primary"
                            block
                            large
                            rounded
                            ><v-icon left>mdi-check</v-icon>
                            ENVIAR</v-btn>

                        <v-btn
                            color="primary"
                            large
                            outlined
                            block
                            rounded
                            elevation="0"
                            class="mt-4" 
                            @click="$router.push({ path: '/'})">
                            <v-icon left>mdi-cancel</v-icon>CANCELAR
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
                </v-col>
                <snackbar
                :text="snackbarMessage"
                    :color="snackbarColor"
                />
            

        <v-dialog v-model="dialog" width="400">
            <v-card outlined elevation="4">
                <v-card-title>Aviso</v-card-title>
                <v-card-text>
                    <div class="text--primary espaco-top" v-html="returnedMessage">
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="primary"
                    large
                    outlined
                    rounded class="text-right" @click="close">CONFIRMAR</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import snackbarMixin from "../../mixins/snackbar.mixin";
import Cpf from '../../components/masked/cpf.vue';
import userService from '../../services/users.service';

export default {
    mixins: [snackbarMixin],
    components: {
        "v-text-field-cpf": Cpf,
    },    
    data(){
        return {
            valid: false,
            login: '',
            cpf: '',
            email: '',
            dialog:false,
            returnedMessage: '',
            resetOK: false,
            rules: {
                requiredRules: {
                required: value => !!value || 'Campo obrigatório',
                }
            }
        };
    },
    methods:{
        close(){
            this.dialog = false;
            if(this.resetOK)
                this.$router.push({ name : 'login' });
        },
        submit(){
            if (this.$refs.form.validate()
                && (this.cpf != null && this.cpf.length > 10)) {
                    this.$store.state.loading = true;
                    var data = {
                        login: this.login,
                        cpf: this.cpf,
                    };
                        
                    userService.resetForgottenPassword(data)
                    .then((res) => {
                        if(res != null && res.data != null && res.data.Mensagem != null && res.data.Mensagem != ""){
                            this.returnedMessage = res.data.Mensagem.replace(/\\n/g,"<br />");
                            this.resetOK = (res.data.Status != null && res.data.Status == "OK");
                        } else {
                            this.returnedMessage = "Não foi possível finalizar a solicitação. Por favor, consulte seu email e caso não tenha recebido os dados para reinício, faça a solicitação novamente.";
                            this.resetOK = false;
                        }
                        this.returnedMessage = this.returnedMessage.replace(/\\r\\n/g,"<br />")
                        this.$store.state.loading = false;
                        this.dialog = true;
                    }).catch(error=>{
                        this.$store.state.loading = false;
                        console.log(error);
                        this.showSnackbar('Não foi possível finalizar a solicitação. Por favor, consulte seu email e caso não tenha recebido os dados para reinício, faça a solicitação novamente.', 'error');
                    });
               }
               else {
                   this.showSnackbar('Campos inválidos ou não informados, por favor verifique o Login e CPF.','error');
               }
        }
    }
}
</script>
<style scoped>

</style>